import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    incidents: null,
    previewIncident: null,
    loading: false,
    error: null,
    search: '',
    pageNumber: 1,
    pageSize: 10,
    filteredColumns: [],
    alertDrawer: false
};
export const fetchIncidents = createAsyncThunk('incidentDetail/fetchIncidents', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { search, pageNumber, pageSize, filteredColumns } = state.incidentDetail;
    const params = {
        searchString: search,
        pageNumber,
        pageSize,
        filteredColumns
    };
    try {
        const response = await itwApi.post('Incident/get-incident-detail', params);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch assets');
    }
});
export const fetchPreviewIncident = createAsyncThunk('incidentDetail/fetchIncidentPreview', async (id, { getState, rejectWithValue }) => {
    try {
        const response = await itwApi.get('Incident/get-preview-for-incident-detail', {
            params: { id }
        });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch incident preview');
    }
});
export const fetchIncidentExcel = createAsyncThunk('incidentDetail/fetchIncidentExcel', async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const { search, filteredColumns } = state.incidentDetail;
    const params = {
        filteredColumns,
        searchString: search
    };
    try {
        const response = await itwApi.post('Incident/generate-sheet', params, {
            responseType: 'blob'
        });
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Incident_Report_${new Date().toISOString()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        return true;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to download Excel file');
    }
});
export const incidentSlice = createSlice({
    name: 'incidentDetail',
    initialState,
    reducers: {
        clearIncidents: (state) => {
            state.incidents = null;
        },
        clearPreviewIncident: (state) => {
            state.previewIncident = null;
        },
        clearFilters: (state) => {
            state.filteredColumns = [];
        },
        resetPagination: (state) => {
            state.pageNumber = 1;
            state.pageSize = 10;
        },
        closeDrawer(state) {
            state.alertDrawer = !state.alertDrawer;
        },
        setSearch: (state, action) => {
            state.search = action.payload;
        },
        clearSearch: (state) => {
            state.search = '';
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setAddFilter: (state, action) => {
            if (action.payload.length === 0) {
                state.filteredColumns = [];
                return;
            }
            state.filteredColumns = action.payload.filter((filter) => !action.payload.some((newFilter) => newFilter.key === filter.key && newFilter.value === ''));
            state.filteredColumns.forEach((newFilter) => {
                const existingIndex = action.payload.findIndex((filter) => filter.key === newFilter.key);
                if (existingIndex !== -1) {
                    state.filteredColumns[existingIndex].value = newFilter.value;
                }
                else {
                    state.filteredColumns.push(newFilter);
                }
            });
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchIncidents.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchIncidents.fulfilled, (state, action) => {
            state.loading = false;
            state.incidents = action.payload;
        })
            .addCase(fetchIncidents.rejected, (state, action) => {
            state.loading = false;
            state.error = null;
        })
            .addCase(fetchIncidentExcel.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchIncidentExcel.fulfilled, (state) => {
            state.loading = false;
        })
            .addCase(fetchIncidentExcel.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(fetchPreviewIncident.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchPreviewIncident.fulfilled, (state, action) => {
            state.loading = false;
            state.previewIncident = action.payload;
        })
            .addCase(fetchPreviewIncident.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    }
});
export const { clearIncidents, setSearch, clearFilters, setPageNumber, setPageSize, setAddFilter, clearPreviewIncident, resetPagination, closeDrawer, clearSearch } = incidentSlice.actions;
export default incidentSlice.reducer;
